import { useEffect } from 'react';
import { api } from '~/trpc-extra/api';

// This component is used to invalidate the cache when the user connects their Slack account.
// It is used in the parent-child window communication pattern.
// See slack/redirect.tsx page for more details.

declare global {
  // oxlint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    onSlackAuthComplete?: () => void;
  }
}

export function SlackHookUpdater({ projectId, testSuiteId }: { projectId: string; testSuiteId?: string }) {
  const trpcUtils = api.useUtils();

  useEffect(() => {
    window.onSlackAuthComplete = () => {
      trpcUtils.project.hasSlackInstalled.invalidate({ projectId, testSuiteId }).catch(() => undefined);
      trpcUtils.project.listSlackConfigs.invalidate({ projectId, testSuiteId }).catch(() => undefined);
    };

    return () => {
      if (window.onSlackAuthComplete) {
        delete window.onSlackAuthComplete;
      }
    };
  }, [projectId, testSuiteId, trpcUtils]);

  return null;
}
